import { router } from '@inertiajs/react'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { CircleDollarSignIcon } from 'lucide-react'

const currencies = ['JPY', 'USD'] as const

export function CurrencySelect({ value }: { value: string }) {
  return (
    <Select
      value={value}
      onValueChange={(currency) => {
        const params = new URLSearchParams(window.location.search)
        params.set('currency', currency)

        router.get(window.location.pathname, Object.fromEntries(params), {
          preserveState: true,
          preserveScroll: true,
        })
      }}
    >
      <SelectTrigger size="sm" className="w-[110px] text-[13px]" aria-label="Display currency">
        <div className="flex items-center gap-2">
          <CircleDollarSignIcon />
          <SelectValue />
        </div>
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {currencies.map((currency) => (
            <SelectItem key={currency} value={currency}>
              {currency}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
